import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import dateFormat from "dateformat";


function PersonalInfo() {
	
    const user = useSelector(state => state.authentication.user);
    const efpPartner = useSelector(state => state.authentication.user.efpPartners)
	
	useEffect(() => {
        //dispatch(userActions.getAll());
        
        
    }, []);
    
    return (
   		<div>
	  		<div className="container-fluid">
	    		<div className="col-md-8" >
	    			<h3>Personal Information</h3>
	    		</div>
    		</div>
    		<div className="container-fluid">
				<div className="col-md-12 border border-secondary" >
					<form name="form"  className="col-md-4 " >
					<div className="form-group">
						<label  className="control-label">User Name</label>
						<input type="text" name="userName" value={user.fullName}  className='form-control' disabled />
					</div>
					<div className="form-group">
						<label  className="control-label">Company</label>
						<input type="text" name="userName" value={efpPartner.bpCompanyName} className='form-control'  disabled />
					</div>
					<div className="form-group">
						<label  className="control-label">Phone Number</label>
						<input type="text" name="userName" value={user.officePhone} className='form-control'  disabled />
					</div>
					<div className="form-group">
						<label  className="control-label">Email Address</label>
						<input type="text" name="userName" value={user.email} className='form-control'  disabled />
					</div>
					<div className="form-group">
						<label  className="control-label">Job Title</label>
						<input type="text" name="userName" value={user.jobTitle} className='form-control'  disabled />
					</div>
					
				</form>
    		</div>
     		</div>
		</div>
    );
}

export { PersonalInfo };